module.exports = __webpack_public_path__ + "img/HongKongTrust10.316b3bc3.png";